import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Doctors from "@/pages/Doctors";
import Pharmacies from "@/pages/Pharmacies";
import Products from "@/pages/Products";
import Visits from "@/pages/Visits";
import Orders from "@/pages/Orders";
import Collections from "@/pages/Collections";
import Inventory from "@/pages/Inventory";
import MarketIntel from "@/pages/MarketIntel";
import Expenses from "@/pages/Expenses";
import CashFlow from "@/pages/CashFlow";
import Performance from "@/pages/Performance";
import Users from "@/pages/Users";
import WhatsApp from "@/pages/WhatsApp";
import MapView from "@/pages/MapView";
import RoutePlanner from "@/pages/RoutePlanner";
import AuditLog from "@/pages/AuditLog";
import Customers from "@/pages/Customers";
import Quotations from "@/pages/Quotations";
import Invoices from "@/pages/Invoices";
import CompanySettings from "@/pages/CompanySettings";
import WeeklyPlans from "@/pages/WeeklyPlans";
import PlanDashboard from "@/pages/PlanDashboard";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordPages";
import { ThemeProvider } from "@/contexts/ThemeContext";

const Protected = ({ children, roles, perm }) => (
  <ProtectedRoute roles={roles} perm={perm}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<Protected perm="dashboard.view"><Dashboard /></Protected>} />
              <Route path="/doctors" element={<Protected perm="doctors.view"><Doctors /></Protected>} />
              <Route path="/pharmacies" element={<Protected perm="pharmacies.view"><Pharmacies /></Protected>} />
              <Route path="/products" element={<Protected perm="products.view"><Products /></Protected>} />
              <Route path="/visits" element={<Protected perm="visits.view_own"><Visits /></Protected>} />
              <Route path="/orders" element={<Protected perm="orders.view_own"><Orders /></Protected>} />
              <Route path="/collections" element={<Protected perm="collections.view_own"><Collections /></Protected>} />
              <Route path="/inventory" element={<Protected perm="inventory.view"><Inventory /></Protected>} />
              <Route path="/market-intel" element={<Protected perm="market_intel.view"><MarketIntel /></Protected>} />
              <Route path="/expenses" element={<Protected perm="expenses.view"><Expenses /></Protected>} />
              <Route path="/cashflow" element={<Protected perm="cashflow.view"><CashFlow /></Protected>} />
              <Route path="/performance" element={<Protected perm="performance.view"><Performance /></Protected>} />
              <Route path="/users" element={<Protected perm="users.view"><Users /></Protected>} />
              <Route path="/whatsapp" element={<Protected perm="whatsapp.view"><WhatsApp /></Protected>} />
              <Route path="/map" element={<Protected perm="map.view"><MapView /></Protected>} />
              <Route path="/routes" element={<Protected perm="routes.manage"><RoutePlanner /></Protected>} />
              <Route path="/audit" element={<Protected perm="audit.view"><AuditLog /></Protected>} />
              <Route path="/customers" element={<Protected perm="customers.view"><Customers /></Protected>} />
              <Route path="/quotations" element={<Protected perm="quotations.view_own"><Quotations /></Protected>} />
              <Route path="/invoices" element={<Protected perm="invoices.view_own"><Invoices /></Protected>} />
              <Route path="/settings/company" element={<Protected perm="settings.company.view"><CompanySettings /></Protected>} />
              <Route path="/plans" element={<Protected perm="plans.view_own"><WeeklyPlans /></Protected>} />
              <Route path="/plan-dashboard" element={<Protected perm="plans.view_own"><PlanDashboard /></Protected>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
